export const Utils =  {
    openAccountDeactivatedAlert: (w, data) => {
        if(!data) data={};
        w.dispatchEvent(new CustomEvent("showAccountDeactivatedAlert", {
            detail: data
        }));
    }
}